module.exports = __webpack_public_path__ + "static/media/3.946efa63.png";